<!--
 * @Author: wzh
 * @LastEditTime: 2023-01-06 17:42:42
 * @Description: 
-->
<!--
 * @Description: 单处登录
-->
<template>
	<div class="simply_login">
		<NavBar
			:title="$t(`webapp.menus.${$route.meta.field}`)"
			:left-arrow="$route.meta.isShowArrow"
			@click-left="$router.back()"
			nav-bar-icon-color="#000"
			class="navbarSelf"
		></NavBar>

		<div class="content">
			<Icon name="warning" color="#FAAD14" size="50" />
			<div style="text-align: left">{{ $t("login.simply_login.tip") }}</div>
			<div style="margin: 30px 0">
				<Button round block type="info" @click="handleOk">{{ $t("base.btn.continue_login") }}</Button>
				<Button style="margin-top: 10px" round block @click="goLogin">{{ $t("base.btn.back_login") }}</Button>
			</div>
		</div>
	</div>
</template>

<script>
import { commonAPI } from "@/apis";
import { Icon, Button, NavBar } from "vant";
import { commonMethods } from "./mixins/common";
import { toast } from "@/utils/toast";

export default {
	name: "SimplyLogin",
	components: { Icon, Button, NavBar },
	mixins: [commonMethods],
	data() {
		return {
			before_login: {},
		};
	},

	created() {
		// 判断是否浏览器回退前进进入
		let before_login = JSON.parse(sessionStorage.getItem("BEFORE_LOGIN"));
		if (!before_login || !before_login.noSingleLogin) {
			this.$router.replace({ path: "/mlogin" });
		} else {
			this.before_login = { ...before_login };
		}
	},
	methods: {
		async handleOk() {
			const { code, message } = await commonAPI.getAction("/users/Offline");
			if (code == 0) {
				toast(message);
				this.before_login.noSingleLogin = false;
				sessionStorage.setItem("BEFORE_LOGIN", JSON.stringify(this.before_login));
				this.jumpComputed();
			} else {
				toast(message);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/base.scss";
.simply_login {
	height: 100vh;
	// background-color: #fff;
	overflow-y: hidden;
	.content {
		margin-top: 100px;
		padding: 0 15px;
		text-align: center;
		font-size: 16px;
		line-height: 30px;
	}
}
</style>
